<template>
	
	<div class="data-table">
		<div class="Work-description">
			<div>
				<p class="w-100" style="font-weight: bold;margin: 1.25rem 0;"><b>ANOMALIA RISCONTRATA</b></p>
				<p v-html="printText(revision.anomalyDescription)"></p>
			</div>
			<div>
				<p class="w-100" style="font-weight: bold;margin: 1.25rem 0;"><b STYLE="text-transform: uppercase">DESCRIZIONE ATTIVITà</b></p>
				<p v-html="printText(revision.activityDescription)"></p>
			</div>
		</div>
	</div>	
</template>
<style lang="scss">
	.Work-description{
		width: 100%;
		> div{
			border-bottom: 1px solid ;
		}
	}
</style>
<script>
	export default{
		name: 'print-activity-details',
		props: {
			revision: Object
		},
		methods:{
			printText(val){
				return val ?  val.replace(/(?:\r\n|\r|\n)/g, '<br />') : ''
			}
		}
	}
</script>